import { render, staticRenderFns } from "./upload_single.vue?vue&type=template&id=3987bc9e&scoped=true"
import script from "./upload_single.vue?vue&type=script&lang=js"
export * from "./upload_single.vue?vue&type=script&lang=js"
import style0 from "./upload_single.vue?vue&type=style&index=0&id=3987bc9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987bc9e",
  null
  
)

export default component.exports